import { Routes } from '@angular/router';
import { PATH } from '../enums/routes.enum';
import {
  formBuilderListResolver,
  formBuilderResolver,
} from '../../features/form-builder/resolvers';
import { usersManagementResolver } from '../../features/users-management/resolvers';
import { AuthRedirectGuard } from '../guards/auth-redirect.guard';
import { rolesManagementResolver } from '../../features/roles-management/resolvers';
import {
  AuthGuard,
  RegisterGuard,
  RolesGuard,
  formTemplateAccessGuard,
} from '../guards';
import { CurrentUserResolver } from '../../features/login/resolvers';

export const routes: Routes = [
  { path: '', redirectTo: PATH.LOGIN, pathMatch: 'full' },
  {
    path: PATH.LOGIN,
    canActivate: [AuthRedirectGuard],
    loadComponent: () =>
      import('../../features/login/login.component').then(
        (m) => m.LoginComponent,
      ),
  },
  {
    path: PATH.REGISTER,
    canActivate: [RegisterGuard, AuthRedirectGuard],
    loadComponent: () =>
      import('../../features/register/register-user.component').then(
        (m) => m.RegisterUserComponent,
      ),
  },
  {
    path: PATH.FORGOT_PASSWORD,
    canActivate: [AuthRedirectGuard],
    loadComponent: () =>
      import('../../features/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent,
      ),
  },
  {
    path: PATH.RESET_PASSWORD,
    canActivate: [AuthRedirectGuard],
    loadComponent: () =>
      import('../../features/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent,
      ),
  },
  {
    path: PATH.CHANGE_PASSWORD,
    loadComponent: () =>
      import(
        '../../features/change-password/components/change-password.component'
      ).then((m) => m.ChangePasswordComponent),
    canActivate: [AuthGuard],
  },
  {
    path: PATH.USERS_MANAGEMENT,
    loadComponent: () =>
      import('../../features/users-management/users-management.component').then(
        (m) => m.UsersManagementComponent,
      ),
    canActivate: [AuthGuard, RolesGuard],
    resolve: {
      currentUser: CurrentUserResolver,
      users: usersManagementResolver,
    },
  },
  {
    path: PATH.ROLES_MANAGEMENT,
    loadComponent: () =>
      import('../../features/roles-management/roles-management.component').then(
        (m) => m.RolesManagementComponent,
      ),
    canActivate: [AuthGuard, RolesGuard],
    resolve: {
      roles: rolesManagementResolver,
    },
  },
  {
    path: PATH.FORM_BUILDER,
    loadComponent: () =>
      import('../../features/form-builder/form-list/form-list.component').then(
        (m) => m.FormListComponent,
      ),
    canActivate: [AuthGuard, RolesGuard],
    resolve: {
      formTemplates: formBuilderListResolver,
    },
    children: [
      {
        path: 'template-builder',
        loadComponent: () =>
          import('../../features/form-builder/form-builder.component').then(
            (m) => m.FormBuilderComponent,
          ),
        canActivate: [AuthGuard, RolesGuard],
      },
      {
        path: ':templateId',
        loadComponent: () =>
          import('../../features/form-builder/form-builder.component').then(
            (m) => m.FormBuilderComponent,
          ),
        canActivate: [AuthGuard, RolesGuard, formTemplateAccessGuard],
        resolve: {
          formTemplates: formBuilderResolver,
        },
      },
    ],
  },
  {
    path: PATH.REPORTS,
    loadComponent: () =>
      import('../../features/reports/reports-list.component').then(
        (m) => m.ReportsListComponent,
      ),
    canActivate: [AuthGuard, RolesGuard],
  },
  {
    path: PATH.REPORT + '/:reportId',
    loadComponent: () =>
      import('../../features/report/report.component').then(
        (m) => m.ReportComponent,
      ),
    canActivate: [AuthGuard],
  },
];
